import { trackMakeEvent, IN_FLOW_SUBSCRIPTION_PURCHASE } from "utils/makeEventUtils";
import EcardPresenter from "presenters/EcardPresenter";

import useAlgoliaEvents from "./useAlgoliaEvents";
import useAlgoliaTracker from "./useAlgoliaTracker";
import useMakes from "./useMakes";
import useLastEcard from "./useLastEcard";

const usePaymentEvents = () => {
  const { trackEventAfterSearchAndPurchase } = useAlgoliaEvents();
  const { hitSelected } = useAlgoliaTracker();
  const { updateMake } = useMakes();
  const { ecard, isMake } = useLastEcard();

  const onSuccessfulInFlowPayment = async () => {
    if (ecard) {
      const templateGroupId = EcardPresenter.templateGroupId(ecard);
      if (templateGroupId === hitSelected?.objectID) trackEventAfterSearchAndPurchase(hitSelected);

      if (isMake) {
        await trackMakeEvent(ecard, IN_FLOW_SUBSCRIPTION_PURCHASE);
        await updateMake(ecard);
      }
    }
  };

  return { onSuccessfulInFlowPayment };
};

export default usePaymentEvents;
